// extracted by mini-css-extract-plugin
export default {"Main":"BookSlideShow_Main__xMhY+","Background":"BookSlideShow_Background__XbSVS"};